import React from 'react';
import { connect } from 'react-redux';

import { sortNumberDesc } from '../../helper/utils';
import { getMessage } from '../../reducers/i18n';
import { getGalleryData } from '../../reducers/patterns';
import PatternGalleries from './PatternGalleries';

const Newest = props => (
    <PatternGalleries {...props} />
    );

const makeMapStateToProps = initialState => {
    const title = getMessage(initialState, 'NEWEST_PATTERNGALLERY_TITLE');
    return state => {
        const { totalHits, patterns, items } = getGalleryData(state);
        const sorted = items.sort(sortNumberDesc);
        return {
            title,
            patterns,
            items: sorted,
            totalHits: 99,
        };
    };
};

export default connect(makeMapStateToProps)(Newest);



// WEBPACK FOOTER //
// ./src/components/patterngalleries/Newest.js